import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';

const desktopBreakpoint = 768;
let init = false;
let swiper;

function sliderSize() {
  const slider = document.querySelector('.cards-swiper');
  const container = document.querySelector('.carousel-container');
  const swiperColumn = container.querySelector('.swiper-column');

  if (window.innerWidth >= desktopBreakpoint) {
    const sliderToEdgeWidthSize =
      (window.innerWidth - container.clientWidth) / 2 - 8;
    const swiperColumnWidth = swiperColumn.clientWidth;
    slider.style.width = sliderToEdgeWidthSize + swiperColumnWidth - 32 + 'px';
  } else {
    // Mobile sizing logic
    slider.style.width = ''; // Reset to default or set a specific size for mobile
  }
}

function initiateSwiper() {
  const slider = document.querySelector('.cards-swiper');
  if (!slider) {
    console.warn('Slider element not found');
    return;
  }

  const swiperWrapper = slider.querySelector('.swiper-wrapper');
  const slides = slider.querySelectorAll('.swiper-slide');

  if (!swiperWrapper || !slides.length) {
    console.warn('Swiper elements not found');
    return;
  }

  if (!init) {
    init = true;
    swiper = new Swiper(slider, {
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-previous',
      },
      a11y: {
        prevSlideMessage: _x(
          'Previous slide',
          'carousel previous button',
          'vtx'
        ),
        nextSlideMessage: _x('Next slide', 'carousel next button', 'vtx'),
        slideRole: false,
        slideLabelMessage: '',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 16,
          scrollbar: {
            el: '.carousel-scrollbar-mb',
            draggable: true,
          },
        },
        1280: {
          slidesPerView: 2.5,
          spaceBetween: 36,
          scrollbar: {
            el: '.carousel-scrollbar',
            draggable: true,
          },
        },
      },
    });
  } else if (init) {
    init = false;
    swiper.update();
  }
}

function handleResize() {
  sliderSize();
  initiateSwiper();
}

domReady(() => {
  initiateSwiper();
  sliderSize();

  document.querySelectorAll('.video-modal').forEach((modal) => {
    modal.addEventListener('hide.bs.modal', () => {
      if (modal.contains(modal.ownerDocument.activeElement)) {
        modal.ownerDocument.activeElement.blur();
      }

      const iframe = modal.querySelector('iframe');
      if (iframe) {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
          'https://www.youtube-nocookie.com'
        );
      }
    });
  });
});

window.addEventListener('resize', handleResize);
